import URI from "abusesa-js/URI";
import * as State from "./State";

const MOVED_ARGS = ["charts", "exposed", "selected", "config", "colors", "datasets"];

export function cleanChartConf(chart) {
    let res = {};
    const valueTypes = ["string", "number", "boolean"];
    const ignored = ["error", "id"];

    if (!chart.type) {
        res.type = "BarChart";
    }

    Object.keys(chart).forEach(key => {
        if (ignored.indexOf(key) !== -1) {
            return;
        }
        let val = chart[key];
        if (valueTypes.indexOf(typeof val) >= 0 || Array.isArray(val)) {
            res[key] = val;
        }
    });

    return res;
}

// migrate old query parameter based url to new hash based url
export function migrateUrl(url = window.location, args = MOVED_ARGS) {
    const uri = new URI(url);
    const urlparams = uri.getData();
    let moved = {};
    for (let key of args) {
        try {
            moved[key] = JSON.parse(urlparams[key]);
            delete urlparams[key];
        } catch (e) {
            //skip
        }
    }

    if (moved.config) {
        let rootconf = moved.config;
        delete moved.config;
        moved = {...rootconf, ...moved};
    }

    uri.setData(urlparams);

    let cleaned = uri.toString();

    let newUrl = generateUrl({...moved}, cleaned);
    if (newUrl.hash && newUrl.toString() != url.href) {
        window.history.replaceState(window.history.state, document.title, newUrl.toString());
    }
}

export function parse(url) {
    let uri = new URI(url);

    let urlparams = uri.getData() || {};
    let state = State.decode(uri.hash) || {};

    return {urlparams, state};
}

export function generateUrl(state, baseUrl = window.location) {
    let {exposed, selected, charts} = state;

    if (charts){
        charts = charts.map(cleanChartConf);
    }

    let data = {charts, exposed, selected};

    for (let key of Object.keys(data)) {
        let val = data[key];
        if (val === void 0) {
            delete data[key];
        }
    }

    let url = new URI(baseUrl);

    url.hash = Object.keys(data).length > 0 ? State.encode(data) : null;

    return url;
}

export function save(state, push = false) {
    let url = generateUrl(state);
    let method = push ? "pushState" : "replaceState";

    window.history[method](state, document.title, url.toString());
}


// WEBPACK FOOTER //
// ./src/kpi/lib/history.js